import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

interface UseFetchWeekByWeekBVParams {
  limit?: number;
}

export const useFetchWeekByWeekBV = (params?: UseFetchWeekByWeekBVParams) => {
  const { limit = 10 } = params || {};

  const queryFn = async ({ pageParam = 1 }) => {
    const response = await fetchClient.GET("/nft/week-by-week-bv", {
      params: {
        query: {
          page: typeof pageParam === "number" ? pageParam : 1,
          limit,
        },
      },
    });
    const error = response.error;
    if (error) throw error;
    return response.data;
  };

  return useInfiniteQuery({
    queryKey: ["user", "week-by-week-bv", limit],
    queryFn,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.pagination;

      if (pagination?.hasNextPage) return pagination.page + 1;

      return undefined;
    },
    // refetchOnMount used to be false, so visiting this tab could show
    // whatever was cached from before the buyer's most recent calculation --
    // indefinitely, since nothing else was invalidating this key either (see
    // useCalculateWeekFinal.ts). Left refetchOnReconnect/refetchInterval
    // off; only mount/focus need to catch up on state that changed
    // elsewhere.
    refetchOnReconnect: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
  });
};
